// utils/phoneValidation.js - Phone number validation for Twilio WhatsApp format

export const validateWhatsAppNumber = (number) => {
  if (!number || number.trim() === '') return { isValid: true, error: '' }; // Allow empty numbers
  
  // Remove spaces and check format
  const cleaned = number.replace(/\s/g, '');
  
  // Must start with + and have 10-15 digits (international format)
  const phoneRegex = /^\+[1-9]\d{9,14}$/;
  
  if (!phoneRegex.test(cleaned)) {
    return {
      isValid: false,
      error: 'Phone number must be in international format (e.g., +14702636277 for US, +911234567890 for India)'
    };
  }
  
  // Additional regional validations
  if (cleaned.startsWith('+1') && cleaned.length !== 12) {
    return {
      isValid: false,
      error: 'US/Canada numbers must be +1 followed by 10 digits (e.g., +14702636277)'
    };
  }
  
  if (cleaned.startsWith('+91') && cleaned.length !== 13) {
    return {
      isValid: false,
      error: 'India numbers must be +91 followed by 10 digits (e.g., +911234567890)'
    };
  }
  
  return { isValid: true, error: '' };
};

export const formatWhatsAppNumber = (number) => {
  if (!number) return '';
  
  // Remove all non-digits and plus signs
  const cleaned = number.replace(/[^\d+]/g, '');
  
  // Ensure it starts with +
  if (cleaned && !cleaned.startsWith('+')) {
    return '+' + cleaned;
  }
  
  return cleaned;
};